const SUPABASE_STORAGE_KEY = "mincool.supabase.auth";
const SUPABASE_EXTRA_STORAGE_PATTERNS = ["sb-", "supabase.auth", "code-verifier"];

function canUseWindow() {
  return typeof window !== "undefined";
}

function getStorageTargets() {
  if (!canUseWindow()) {
    return [];
  }
  return [window.localStorage, window.sessionStorage].filter(Boolean);
}

function parseStoredPayload(rawValue = "") {
  if (!rawValue) {
    return null;
  }
  try {
    return JSON.parse(rawValue);
  } catch {
    return null;
  }
}

function decodeJwtPayload(token = "") {
  const [, payload = ""] = String(token || "").split(".");
  if (!payload) {
    return {};
  }
  const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
  const padding = "=".repeat((4 - (normalized.length % 4 || 4)) % 4);
  try {
    const decoded = atob(`${normalized}${padding}`);
    return JSON.parse(decoded);
  } catch {
    return {};
  }
}

function sessionFromStoredPayload(payload) {
  if (!payload || typeof payload !== "object") {
    return null;
  }
  if (payload.currentSession && typeof payload.currentSession === "object") {
    return payload.currentSession;
  }
  if (payload.session && typeof payload.session === "object") {
    return payload.session;
  }
  if (typeof payload.access_token === "string") {
    return payload;
  }
  return null;
}

function tokenExpirySeconds(session) {
  if (Number.isFinite(session?.expires_at)) {
    return Number(session.expires_at);
  }
  const payload = decodeJwtPayload(session?.access_token || "");
  return Number.isFinite(payload?.exp) ? Number(payload.exp) : null;
}

function isAnonymousSession(session) {
  if (session?.user && typeof session.user === "object") {
    return Boolean(session.user.is_anonymous);
  }
  const payload = decodeJwtPayload(session?.access_token || "");
  return Boolean(payload?.is_anonymous);
}

export function readStoredSupabaseSession() {
  for (const store of getStorageTargets()) {
    const payload = parseStoredPayload(store.getItem(SUPABASE_STORAGE_KEY));
    const session = sessionFromStoredPayload(payload);
    if (session) {
      return session;
    }
  }
  return null;
}

export function hasAuthenticatedStoredSupabaseSession() {
  const session = readStoredSupabaseSession();
  if (!session?.access_token) {
    return false;
  }
  const expirySeconds = tokenExpirySeconds(session);
  if (expirySeconds && expirySeconds <= Math.floor(Date.now() / 1000)) {
    return false;
  }
  if (isAnonymousSession(session)) {
    return false;
  }
  return true;
}

export function clearStoredSupabaseSession() {
  for (const store of getStorageTargets()) {
    const keysToRemove = [];
    for (let index = 0; index < store.length; index += 1) {
      const key = String(store.key(index) || "");
      if (!key) {
        continue;
      }
      if (
        key === SUPABASE_STORAGE_KEY
        || SUPABASE_EXTRA_STORAGE_PATTERNS.some((pattern) => key.startsWith(pattern) || key.includes(pattern))
      ) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) {
      store.removeItem(key);
    }
  }
}

